import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function TopView({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 18 24' {...props}>
      <Path
        d='M14.7143 11.2749L17 11.2863'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.28516 11.2749L0.999442 11.2863'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.28627 11.2778L4.63827 9.32583C5.27827 8.40126 6.33199
         7.84926 7.45656 7.84926L10.5446 7.84926C11.6691 7.84926 12.7228
          8.40126 13.3628 9.32583L14.7148 11.2778'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.71484 1.00056L11.2863 1.00056C13.18 1.00056 14.7148
         2.71599 14.7148 4.83249L14.7148 20.1602C14.7148 21.5717 13.692
          22.7148 12.4291 22.7148L5.57199 22.7148C4.30913 22.7148 3.28627
           21.5716 3.28627 20.1602L3.28627 4.83249C3.28627 2.71599 4.82113 1.00056 6.71484 1.00056Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.28627 18.1434L14.7148 18.1434'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

TopView.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default TopView
